export const fmt = (n: number) => n.toLocaleString('en-US')

export const formatHighlightNumber = (n: number): string => {
  if (!Number.isFinite(n)) return String(n)
  if (n === 0) return '0'
  const sign = n < 0 ? '-' : ''
  const abs = Math.abs(n)
  if (abs < 1000) return `${sign}${abs}`
  if (abs < 1_000_000) {
    const k = Math.round(abs / 100) / 10
    return `${sign}${k.toFixed(1).replace(/\.0$/, '')}K`
  }
  const m = Math.round(abs / 100_000) / 10
  return `${sign}${m.toFixed(1).replace(/\.0$/, '')}M`
}

export type SortDir = 'asc' | 'desc'

export const INSIGHTS_CACHE_TTL_SECONDS = 180
